import * as React from 'react'

import { THandoverType } from '~logic/helpers/determineHandoverType'
import { IconLine } from '~ui/components/IconLine/IconLine'
import { IconBranchFill } from '~ui/components/icons/specific/IconBranch'
import { IconDeliveryFill } from '~ui/components/icons/specific/IconDelivery'
import { IconPhone } from '~ui/components/icons/specific/IconPhone'
import { IconTime } from '~ui/components/icons/specific/IconTime'
import { TSpace } from '~ui/styleGuide/spaces'

const PLACE_ICON_SIZE = 2.6
const TIME_ICON_SIZE = 2.8
const PHONE_ICON_SIZE = 2
const ICON_WIDTH = Math.max(PLACE_ICON_SIZE, TIME_ICON_SIZE)
const ICON_SPACING: TSpace = `large`

type TProps = RequiredChildren
type TOrderPlaceProps = TProps & {
  handoverType: Nullable<THandoverType>
}

/**
 * Icon line icon & sizes for order place info.
 */
export const OrderPlaceIconLine: React.FC<TOrderPlaceProps> = ({
  children,
  handoverType = `MESSENGER`,
}) => {
  return (
    <IconLine
      iconAlign={`center`}
      spacing={ICON_SPACING}
      iconColor={`specialColors.company`}
      iconSize={`${PLACE_ICON_SIZE}rem`}
      iconPartForcedWidth={`${ICON_WIDTH}rem`}
      icon={handoverType === `MESSENGER` ? IconDeliveryFill : IconBranchFill}
    >
      {children}
    </IconLine>
  )
}

/**
 * icon line icon & sizes for order time info
 */
export const OrderTimeIconLine: React.FC<TProps> = ({ children }) => {
  return (
    <IconLine
      icon={IconTime}
      iconAlign={`center`}
      spacing={ICON_SPACING}
      iconColor={`specialColors.company`}
      iconSize={`${TIME_ICON_SIZE}rem`}
      iconPartForcedWidth={`${ICON_WIDTH}rem`}
    >
      {children}
    </IconLine>
  )
}

/**
 * icon line icon & sizes for order phone info
 */
export const OrderPhoneIconLine: React.FC<TProps> = ({ children }) => {
  return (
    <IconLine
      icon={IconPhone}
      iconAlign={`center`}
      spacing={ICON_SPACING}
      iconColor={`specialColors.company`}
      iconSize={`${PHONE_ICON_SIZE}rem`}
      iconPartForcedWidth={`${ICON_WIDTH}rem`}
    >
      {children}
    </IconLine>
  )
}
